import moment from "moment-timezone";

/**
 * 🔴 HORA DE PARED — la única forma correcta de leer estas fechas.
 *
 * Hay dos clases de fecha en el sistema y confundirlas es el fallo que más tiempo ha
 * durado en este proyecto:
 *
 *   · INSTANTE — `createdAt`, `deliveredAt`, `sentAt`… un momento del tiempo, guardado
 *     en UTC. Para mostrarlo HAY que convertirlo a la zona de la empresa.
 *
 *   · HORA DE PARED — `scheduledAt`, `scheduledDate`, `nextScheduledAt`,
 *     `recurrenceEndDate`, `appointmentDate`. Lo que el cliente escribió: «las 09:00».
 *     **No se convierte nunca.** Convertirla la desplaza.
 *
 * `moment(valor)` a secas la lee en la zona del NAVEGADOR, así que una cita de una
 * empresa de Madrid se mostraba en la hora del ordenador de quien la mirase. Y
 * `parseNaiveDate` del hook asume que todo lo que llega es UTC —lo dice en sus propios
 * comentarios—, lo cual es cierto para los instantes y falso para estas.
 *
 * Medido el 2026-09-12: la base tenía `2026-09-14 09:34` de Shanghái y la lista mostraba
 * `17:34`. Ocho horas.
 *
 * ── POR QUE ESTE FICHERO EXISTE ──
 *
 * Porque la lógica hacía falta en DOS SITIOS que no pueden compartir un hook: los
 * componentes de React y las funciones puras de validación. Sin un sitio común, cada uno
 * se escribía el suyo — llegó a haber SEIS copias de la misma idea, y dos de ellas ni
 * siquiera usaban la zona de la empresa. Esta es la única, y el hook también la usa.
 *
 * Ver doc 0412 §11.
 */

/** Quita cualquier marca de instante: si el backend serializa con `T` o `Z`, sigue siendo pared. */
const limpiar = valor =>
  String(valor).replace("T", " ").split(".")[0].replace("Z", "").trim();

/**
 * Lee una hora de pared en la zona de la empresa.
 * @param {string|Date} valor
 * @param {string} timezone zona IANA de la empresa
 * @returns {moment.Moment|null}
 */
export const parsePared = (valor, timezone) => {
  if (!valor) return null;
  const tz = timezone || "America/Lima";
  const m = moment.tz(limpiar(valor), "YYYY-MM-DD HH:mm:ss", tz);
  return m.isValid() ? m : null;
};

/** La misma pared, ya formateada para mostrar. */
export const formatPared = (valor, timezone, formato = "DD/MM/YYYY HH:mm") => {
  const m = parsePared(valor, timezone);
  return m ? m.format(formato) : "";
};
